/**
 * View component for /user-modules/:userModuleId/update
 *
 * Updates a single userModule from a copy of the selcted userModule
 * as defined in the userModule reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userModuleActions from '../userModuleActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import UserModuleForm from '../components/UserModuleForm.js.jsx';
import UserModuleLayout from '../components/UserModuleLayout.js.jsx';

// import userModule css modules
import userModuleStyles from '../userModuleModuleStyles.css';

class UpdateUserModule extends Base {
  constructor(props) {
    super(props);
    const { selectedUserModule, userModuleMap } = this.props;
    this.state = {
      userModule: userModuleMap[selectedUserModule.id] ? { ...userModuleMap[selectedUserModule.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userModuleActions.fetchSingleIfNeeded(match.params.userModuleId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedUserModule, userModuleMap } = nextProps;
    this.setState({
      userModule: userModuleMap[selectedUserModule.id] ? { ...userModuleMap[selectedUserModule.id] } : {}
      //we don't want to actually change the store's userModule, just use a copy
    })
  }

  _handleFormChange(e) {
    let newUserModuleState = _.update( this.state.userModule, e.target.name, function() {
      return e.target.value;
    });
    this.setState({userModule :newUserModuleState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(userModuleActions.sendUpdateUserModule(this.state.userModule)).then((action) => {
      if(action.success) {
        history.push(`/user-modules/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedUserModule, userModuleMap } = this.props;
    const { userModule } = this.state;
    const isEmpty = (!userModule || userModule._id === null || userModule._id === undefined);
    return  (
      <UserModuleLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedUserModule.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <UserModuleForm
                userModule={userModule}
                cancelLink={`/user-modules/${userModule._id}`}
                formTitle="Update User Module"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </UserModuleLayout>
    )
  }
}

UpdateUserModule.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedUserModule: store.userModule.selected
    , userModuleMap: store.userModule.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateUserModule)
);



// WEBPACK FOOTER //
// modules/userModule/views/UpdateUserModule.js.jsx